// "Filtered programmes" collapsible list. Used twice on the Quick Check
// page — once when there are exclusions but no matches, and again below
// the results grid when the applicant has matches AND exclusions.
// Extracted so both spots stay in visual sync.
export default function ExcludedPanel({
  excluded, intendedShown, defaultOpen = false, className = "",
}) {
  if (!excluded?.length || !intendedShown) return null;
  return (
    <details
      data-testid="excluded-panel"
      open={defaultOpen}
      className={`rounded-md border border-stone-200 bg-stone-50 p-4 group ${className}`}
    >
      <summary className="cursor-pointer list-none flex items-center justify-between">
        <div className="label-uppercase !text-[10px] text-stone-600">
          {excluded.length} {excluded.length > 1 ? "programmes" : "programme"} filtered — {intendedShown} not offered
        </div>
        <span className="text-xs font-mono text-stone-500 group-open:hidden">show ▾</span>
        <span className="text-xs font-mono text-stone-500 hidden group-open:inline">hide ▴</span>
      </summary>
      <ul className="mt-3 text-sm text-stone-700 space-y-1">
        {excluded.map((e, idx) => {
          const k = e.degree_id
            ? `${e.university_id}::${e.degree_id}`
            : `${e.university_id}::${idx}`;
          return (
            <li
              key={k}
              data-testid={`excluded-${e.degree_id || e.university_id}-${idx}`}
            >
              · {e.reason}
            </li>
          );
        })}
      </ul>
    </details>
  );
}
